/* NBA Store Chile - ficha de producto: variantes, galería, carro y ventanas */
(function () {
  'use strict';
  function fmtMoney(cents, format) {
    cents = Number(cents) || 0;
    format = format || '${{amount_no_decimals_with_comma_separator}}';
    function group(n, d, t, s) {
      var fixed = (n / 100).toFixed(d);
      var parts = fixed.split('.');
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, t) + (parts[1] ? s + parts[1] : '');
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case 'amount': return group(cents, 2, ',', '.');
        case 'amount_no_decimals': return group(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return group(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return group(cents, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return group(cents, 0, ' ', ',');
        default: return group(cents, 0, '.', ',');
      }
    });
  }

  function init(root) {
    if (!root || root.dataset.nbaReady) return;
    root.dataset.nbaReady = '1';
    var product, cfg;
    try {
      product = JSON.parse(root.querySelector('[data-nba-product-json]').textContent);
      cfg = JSON.parse(root.querySelector('[data-nba-pdp-config]').textContent);
    } catch (e) { return; }
    var form = root.querySelector('form.nba-pdp__form');
    var idInput = root.querySelector('[data-nba-variant-id]');
    var atc = root.querySelector('[data-nba-atc]');
    var errBox = root.querySelector('[data-nba-error]');
    var opts = Array.prototype.slice.call(root.querySelectorAll('[data-nba-option]'));
    var slides = root.querySelector('[data-nba-slides]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-nba-thumb]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('.nba-pdp__dots span'));
    var prev = root.querySelector('[data-nba-prev]');
    var next = root.querySelector('[data-nba-next]');
    var current = product.variants.filter(function (v) { return idInput && String(v.id) === idInput.value; })[0] || product.variants[0];

    /* ---------- Galería ---------- */
    var count = slides ? slides.children.length : 0;
    function index() { return slides && slides.clientWidth ? Math.round(slides.scrollLeft / slides.clientWidth) : 0; }
    function goTo(i, instant) {
      if (!slides || !count) return;
      i = Math.max(0, Math.min(count - 1, i));
      slides.scrollTo({ left: i * slides.clientWidth, behavior: instant ? 'auto' : 'smooth' });
      mark(i);
    }
    function mark(i) {
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= count - 1;
      var t = thumbs[i];
      if (t && t.parentNode && t.parentNode.parentNode) {
        var list = t.parentNode.parentNode, top = t.parentNode.offsetTop;
        if (top < list.scrollTop || top > list.scrollTop + list.clientHeight - 80) list.scrollTo({ top: top - 10, behavior: 'smooth' });
      }
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-nba-thumb'), 10)); }); });
    if (prev) prev.addEventListener('click', function () { goTo(index() - 1); });
    if (next) next.addEventListener('click', function () { goTo(index() + 1); });
    if (slides) {
      var st;
      slides.addEventListener('scroll', function () { clearTimeout(st); st = setTimeout(function () { mark(index()); }, 60); }, { passive: true });
      window.addEventListener('resize', function () { goTo(index(), true); });
      mark(0);
    }
    function mediaIndex(id) {
      if (!slides || !id) return -1;
      for (var k = 0; k < slides.children.length; k++) if (slides.children[k].getAttribute('data-media-id') === String(id)) return k;
      return -1;
    }

    /* ---------- Variantes ---------- */
    function selected() {
      return opts.map(function (f) { var b = f.querySelector('.nba-pdp__val.is-selected'); return b ? b.getAttribute('data-value') : null; });
    }
    function find(sel) {
      return product.variants.filter(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); })[0];
    }
    function setSelected(sel) {
      opts.forEach(function (f, i) {
        f.querySelectorAll('.nba-pdp__val').forEach(function (b) {
          var on = b.getAttribute('data-value') === sel[i];
          b.classList.toggle('is-selected', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        var lab = f.querySelector('[data-nba-opt-value]');
        if (lab) lab.textContent = sel[i] || '';
      });
    }
    function availability(sel) {
      opts.forEach(function (f, i) {
        f.querySelectorAll('.nba-pdp__val').forEach(function (b) {
          var test = sel.slice(); test[i] = b.getAttribute('data-value');
          var v = find(test);
          b.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }
    var pickupCtrl;
    function refreshPickup(v) {
      var box = root.querySelector('[data-nba-pickup]');
      if (!box || !v) return;
      if (pickupCtrl && pickupCtrl.abort) pickupCtrl.abort();
      pickupCtrl = window.AbortController ? new AbortController() : null;
      var url = root.getAttribute('data-product-url') + '?variant=' + v.id + '&section_id=' + root.getAttribute('data-section-id');
      fetch(url, pickupCtrl ? { signal: pickupCtrl.signal } : {}).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-nba-pickup]');
        if (fresh) box.innerHTML = fresh.innerHTML;
      }).catch(function () {});
    }
    function update(v) {
      current = v;
      if (idInput) idInput.value = v ? v.id : '';
      var now = root.querySelector('[data-nba-now]'), was = root.querySelector('[data-nba-was]');
      if (v && now) {
        var sale = v.compare_at_price && v.compare_at_price > v.price;
        now.textContent = fmtMoney(v.price, cfg.moneyFormat);
        now.classList.toggle('is-sale', !!sale);
        if (was) { was.hidden = !sale; if (sale) was.textContent = fmtMoney(v.compare_at_price, cfg.moneyFormat); }
        var badge = root.querySelector('[data-nba-sale-badge]');
        if (badge) badge.hidden = !sale;
      }
      var ok = !!(v && v.available);
      if (atc) { atc.disabled = !ok; atc.textContent = ok ? atc.getAttribute('data-label') : atc.getAttribute('data-soldout'); }
      var stock = root.querySelector('[data-nba-stock]');
      if (stock) { stock.textContent = ok ? stock.getAttribute('data-in') : stock.getAttribute('data-out'); stock.classList.toggle('is-out', !ok); }
      root.querySelectorAll('[data-nba-sku]').forEach(function (n) { n.textContent = (v && v.sku) || ''; });
      if (errBox) errBox.hidden = true;
      if (v) {
        if (v.featured_media) { var mi = mediaIndex(v.featured_media.id); if (mi > -1) goTo(mi); }
        if (window.history && history.replaceState) history.replaceState({}, '', root.getAttribute('data-product-url') + '?variant=' + v.id);
        refreshPickup(v);
      }
    }
    opts.forEach(function (f, i) {
      f.addEventListener('click', function (e) {
        var b = e.target.closest('.nba-pdp__val');
        if (!b) return;
        var sel = selected();
        sel[i] = b.getAttribute('data-value');
        var v = find(sel);
        if (!v || !v.available) {
          var alt = product.variants.filter(function (x) { return x.options[i] === sel[i] && x.available; })[0];
          if (alt && !v) { sel = alt.options.slice(); v = alt; }
        }
        setSelected(sel);
        availability(sel);
        update(v || null);
      });
    });
    if (opts.length) availability(selected());

    /* ---------- Agregar al carro ---------- */
    if (form && atc) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!current || !current.available) return;
        atc.disabled = true;
        atc.classList.add('is-loading');
        if (errBox) errBox.hidden = true;
        var root_url = cfg.root || '/';
        fetch(root_url + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
          .then(function (res) {
            if (!res.ok) {
              if (errBox) { errBox.textContent = res.d.description || res.d.message || 'No pudimos agregar el producto. Inténtalo nuevamente.'; errBox.hidden = false; }
              return;
            }
            return fetch(root_url + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
              document.querySelectorAll('.cart-count-bubble [data-cart-count]').forEach(function (n) { n.textContent = cart.item_count; });
              var sf = window.sharedFunctions;
              var mode = window.after_add_to_cart && window.after_add_to_cart.type;
              if (mode === 'cart' || !sf || typeof sf.updateSidebarCart !== 'function') {
                window.location.href = cfg.cart || '/cart';
                return;
              }
              document.body.classList.add('cart-sidebar-show');
              sf.updateSidebarCart(cart);
              atc.classList.add('is-added');
              atc.textContent = '¡Agregado!';
              setTimeout(function () { atc.classList.remove('is-added'); atc.textContent = atc.getAttribute('data-label'); }, 1800);
            });
          })
          .catch(function () { form.submit(); })
          .then(function () { atc.classList.remove('is-loading'); atc.disabled = !(current && current.available); });
      });
    }
  }

  /* ---------- Ventanas emergentes ---------- */
  document.addEventListener('click', function (e) {
    var open = e.target.closest ? e.target.closest('[data-nba-dialog-open]') : null;
    if (open) {
      var d = document.getElementById(open.getAttribute('data-nba-dialog-open'));
      if (d && typeof d.showModal === 'function') { e.preventDefault(); d.showModal(); }
      return;
    }
    if (e.target.closest && e.target.closest('[data-nba-dialog-close]')) { var dd = e.target.closest('dialog'); if (dd) dd.close(); return; }
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('nba-dlg')) e.target.close();
  });

  function boot(scope) { (scope || document).querySelectorAll('[data-nba-pdp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
